export default "__VITE_ASSET__k8Kt$Ym6__"